<template>
  <div class="agent_home">
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        label="用户名称"
        align="center"
        prop="name"
      ></el-table-column>
      <el-table-column
        label="手机号码"
        align="center"
        prop="mobile"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="agentUserId"
        label="代理用户ID"
        width="190"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="agentId"
        label="代理配置ID"
        width="190"
        v-if="!isShowMap"
      ></el-table-column>
      <el-table-column
        label="代理名称"
        align="center"
        prop="agentName"
      ></el-table-column>
      <el-table-column
        label="邀请层级"
        align="center"
        prop="hierarchyLevel"
        width="120"
      ></el-table-column>

       <el-table-column
        label="地区代理"
        align="center"
        prop="shortRegionAddress"
        width="120"
        v-if="isShowMap"
      ></el-table-column>

      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="jumpInfo(scope.row)"
            class="comm_but_warp"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <agent-detail
      :detail="detail"
      :dialogVisible="dialogVisible"
      v-if="dialogVisible"
      :key="detail.id"
      @close="dialogVisible = false"
    />
  </div>
</template>

<script>
import { getSubordinateList } from "@/api/dashboard";
import { getLogionUserInfo } from "@/utils/auth"; // 验权
import agentDetail from "@/views/dashboard/agent-detail/index.vue";
export default {
  name: "AgentHome",
  data() {
    return {
      listLoading: false,
      list: [],
      listQuery: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      detail: {},
      dialogVisible: false,
      isShowMap: false,
    };
  },
  created() {
    this.isShowMap = getLogionUserInfo()?.teamLogo == 0; // 0 黄丽账号， 1.显示3D地图
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getSubordinateList(this.listQuery).then((response) => {
        this.list = response.data.entitys;
        this.total = response.data.totalCount;
      });
    },

    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    jumpInfo(row) {
      console.log(row);
      this.dialogVisible = true;
      this.detail = row;
    },
  },
  components: {
    agentDetail,
  },
};
</script>

<style lang="scss" scoped>
.agent_home {
  padding: 20px;
}
</style>
